import { getBaseDomain } from '../network/utils/getBaseDomain';
import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';
import { instrumentationKeys } from './instrumentationKeys';

export const getInstrumentationKey = () => {
  const baseDomain = getBaseDomain;
  const { retailUnit } = getRetailUnitAndLanguage();
  const instrumentationKey = instrumentationKeys[baseDomain]?.[retailUnit];
  if (!instrumentationKey) {
    console.warn(`[MV Agent] AppInsights instrumentation key missing for ${baseDomain}/${retailUnit}`);
    return;
  }
  return instrumentationKey;
};
